import {
    getBillingCodeLoading,
    getBillingCodeRequest,
    getBillingCodeSuccess,
    getBillingCodeReject,
} from "../../actions/billingCode/getAll";

export const getBillingCode = (formData) => async (dispatch, getState) => {
    dispatch(getBillingCodeLoading());
    try {
        const { data } = await getBillingCodeRequest(formData, getState);
        dispatch(getBillingCodeSuccess(data))
    } catch (error) {
        dispatch(getBillingCodeReject(error))
    }
    return Promise.resolve();
};
